import customAxios from '../../customAxios';

import { LOCATION_AREA     } from '../../routes';
import { locationNamespace } from '../../../types/location.namespace';

async function createArea(props: locationNamespace.area.create) {
  try {
    return (await customAxios.post(LOCATION_AREA, props)).data;
  } catch (error: any) {
    console.error({LOCATION_AREA: error});
  }
}

export default createArea;
